(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;

  /* -----------------------------------------------------------------------
     Lens type descriptions (fallback when block subtitle is empty)
     ----------------------------------------------------------------------- */
  var DESCRIPTIONS = {
    'standard': 'Impact-resistant lenses for everyday prescriptions.',
    'premium': 'Lighter lenses with anti-reflective coating for sharper, more comfortable vision. 1.59 index.',
    'premium-ar': 'Anti-reflective, scratch-resistant, and optimized for clear vision.',
    'ultra-thin': 'Our thinnest, lightest lenses with anti-reflective coating, ideal for stronger prescriptions. 1.67 high-index material.'
  };

  var DISPLAY_NAMES = {
    'standard': 'STANDARD',
    'premium': 'PREMIUM',
    'premium-ar': 'PREMIUM AR',
    'ultra-thin': 'ULTRA-THIN'
  };

  /* Per-type lens icons — ACTUAL Figma lens shape path */
  var LENS_PATH = 'M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z';
  var TYPE_ICONS = {
    'standard': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="' + LENS_PATH + '" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'premium': '<svg width="47" height="27" viewBox="0 0 47 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.6602 19.9013L38.5602 7.5813" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.4598 11.7012C44.7198 17.6612 40.8898 22.8912 35.3198 25.1412C33.9898 25.6812 30.6398 26.0412 29.4298 26.0412H17.8698C14.1598 25.9212 11.3498 25.1712 8.6498 23.3312C6.4198 21.8112 4.5898 19.9412 3.2498 17.6212C1.4898 14.5912 0.549805 11.1212 0.549805 7.5212C0.549805 3.6212 4.28981 0.481197 8.84981 0.551197L37.6498 0.941197C45.1398 0.681197 46.1298 6.4112 45.4798 11.7112L45.4598 11.7012Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'premium-ar': '<svg width="47" height="27" viewBox="0 0 47 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.6602 19.9013L38.5602 7.5813" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.4598 11.7012C44.7198 17.6612 40.8898 22.8912 35.3198 25.1412C33.9898 25.6812 30.6398 26.0412 29.4298 26.0412H17.8698C14.1598 25.9212 11.3498 25.1712 8.6498 23.3312C6.4198 21.8112 4.5898 19.9412 3.2498 17.6212C1.4898 14.5912 0.549805 11.1212 0.549805 7.5212C0.549805 3.6212 4.28981 0.481197 8.84981 0.551197L37.6498 0.941197C45.1398 0.681197 46.1298 6.4112 45.4798 11.7112L45.4598 11.7012Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'ultra-thin': '<svg width="54" height="28" viewBox="0 0 54 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M41.9798 10.841C41.2998 16.341 37.7598 21.161 32.6298 23.241C31.3998 23.741 28.3198 24.071 27.1898 24.071H16.5298C13.0998 23.961 10.5198 23.271 8.01981 21.571C5.95981 20.171 4.27981 18.441 3.03981 16.301C1.41981 13.501 0.549805 10.301 0.549805 6.98097C0.549805 3.38097 3.9998 0.490966 8.1998 0.550966L34.7698 0.910966C41.6798 0.670966 42.5998 5.96097 41.9898 10.841H41.9798Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M53.1898 13.9611C52.5098 19.4611 48.9698 24.2811 43.8398 26.3611C42.6098 26.8611 39.5298 27.1911 38.3998 27.1911H27.7398C24.3098 27.0811 21.7298 26.3911 19.2298 24.6911C17.1698 23.2911 15.4898 21.5611 14.2498 19.4211C12.6298 16.6211 11.7598 13.4211 11.7598 10.1011C11.7598 6.50108 15.2098 3.61108 19.4098 3.67108L45.9798 4.03108C52.8898 3.79108 53.8098 9.08108 53.1998 13.9611H53.1898Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var LENS_TYPE_ORDER = {
    'standard': 1,
    'premium': 2,
    'premium-ar': 3,
    'ultra-thin': 4
  };

  var LENS_TYPE_INFO_CONTENT = {
    'premium': 'Thin and durable lenses with anti-reflective and scratch-resistant coatings.<br><b>Recommended For Moderate Prescriptions</b>, offering a balance of clarity, comfort, and value.',
    'premium-ar': 'Thin and durable lenses with anti-reflective and scratch-resistant coatings.<br><b>Recommended For Moderate Prescriptions</b>, offering a balance of clarity, comfort, and value.',
    'ultra-thin': 'Ultra-thin, lightweight lenses for stronger prescriptions.<br>Ideal for ±4.00 and above to reduce thickness and improve comfort.'
  };

  var advanceTimer = null;

  function getLensTypeInfoContent(trigger) {
    var key = trigger.getAttribute('data-info-key');
    var customContent = trigger.getAttribute('data-info-content') || '';
    var i18n = window.WmpI18n || {};
    var info = i18n.info || {};
    var contentKey = key.replace(/-/g, '_');
    var helperContent = LENS_TYPE_INFO_CONTENT[key] || '';

    return helperContent || customContent || info[contentKey] || '';
  }

  function showLensTypeInfo(trigger) {
    if (!window.WmpInfoBubble || !trigger) return;
    WmpInfoBubble.show(trigger, {
      content: getLensTypeInfoContent(trigger),
      toggle: false
    });
  }

  function getLensTypePriceLabel(priceCents, comparePriceCents) {
    if (priceCents === 0) return 'Price Free.';

    var price = store.formatPrice(priceCents);
    if (comparePriceCents && comparePriceCents > priceCents) {
      return 'Sale price ' + price + '. Original price ' + store.formatPrice(comparePriceCents) + '.';
    }
    return 'Price ' + price + '.';
  }

  function appendSrOnly(parent, text) {
    var span = document.createElement('span');
    span.className = 'wmp-sr-only';
    span.textContent = text;
    parent.appendChild(span);
  }

  function renderLensTypePrice(priceEl, priceCents, comparePriceCents) {
    priceEl.innerHTML = '';

    if (priceCents === 0) {
      priceEl.textContent = 'Free';
    } else if (comparePriceCents && comparePriceCents > priceCents) {
      appendSrOnly(priceEl, getLensTypePriceLabel(priceCents, comparePriceCents) + ' ');

      var saleSpan = document.createElement('span');
      saleSpan.className = 'wmp-card__price--sale';
      saleSpan.setAttribute('aria-hidden', 'true');
      saleSpan.textContent = store.formatPrice(priceCents);
      priceEl.appendChild(saleSpan);

      priceEl.appendChild(document.createTextNode(' '));

      var origSpan = document.createElement('s');
      origSpan.className = 'wmp-card__price-original';
      origSpan.setAttribute('aria-hidden', 'true');
      origSpan.textContent = store.formatPrice(comparePriceCents);
      priceEl.appendChild(origSpan);
    } else {
      priceEl.textContent = store.formatPrice(priceCents);
    }
  }

  function toA11ySentence(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    return /[.!?]$/.test(text) ? text : text + '.';
  }

  function buildLensTypeCardLabel(lt, displayName, description, isRecommended) {
    var parts = [displayName];
    if (isRecommended) parts.push('Recommended');
    if (description) parts.push(description);
    parts.push(getLensTypePriceLabel(lt.priceCents, lt.comparePriceCents));
    return parts.map(toA11ySentence).filter(Boolean).join(' ');
  }

  function setCardSelected(card, selected) {
    var selectControl = card.querySelector('.wmp-card__select-control');
    card.classList.toggle('wmp-card--selected', selected);
    if (selectControl) {
      selectControl.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
  }

  /* -----------------------------------------------------------------------
     Recommended badge logic
     ----------------------------------------------------------------------- */
  function getRecommended(rxValues) {
    if (!rxValues) return 'premium';
    var od = rxValues.od || {};
    var os = rxValues.os || {};

    // Ultra-Thin if SPH >= +5 (either eye)
    if ((od.sph !== null && od.sph >= 5) || (os.sph !== null && os.sph >= 5)) {
      return 'ultra-thin';
    }
    // Ultra-Thin if SPH <= -5 AND CYL <= -1.5 (same eye)
    if (od.sph !== null && od.sph <= -5 && od.cyl !== null && od.cyl <= -1.5) {
      return 'ultra-thin';
    }
    if (os.sph !== null && os.sph <= -5 && os.cyl !== null && os.cyl <= -1.5) {
      return 'ultra-thin';
    }

    return 'premium';
  }

  function resolveRecommendedLensType(recommended, lensTypes) {
    if (recommended !== 'premium') return recommended;

    var premiumFallback = null;
    for (var i = 0; i < lensTypes.length; i++) {
      var key = String(lensTypes[i].lensTypeKey || '');
      if (key === 'premium') return key;
      if (premiumFallback === null && key.indexOf('premium') === 0) {
        premiumFallback = key;
      }
    }

    return premiumFallback || recommended;
  }

  /* -----------------------------------------------------------------------
     Rx "lens cutting" limits — apply to ALL prescription types (Single Vision,
     Reading, Progressive) for both clear frames and sunglasses. Non-Prescription
     is excluded (no Rx attached). When the entered Rx is outside the cuttable
     range, Standard AND Premium/Premium AR are hidden so only Ultra-Thin shows.

     Interim limits per spec: SPH -6.00 .. +3.00, |CYL| <= 2.00, identical across
     Clear / Blue Light / Photochromic. Hoisted to one constant so Progressive's
     final (TBD) numbers can be slotted in without touching the logic below.
     ----------------------------------------------------------------------- */
  var RX_CUT_LIMITS = { sphMin: -6, sphMax: 3, cylMax: 2 };

  function restrictToUltraThin(rxType, rxValues) {
    if (rxType === 'non-prescription') return false;
    if (!rxValues) return false;

    var L = RX_CUT_LIMITS;
    var eyes = [rxValues.od, rxValues.os];
    for (var i = 0; i < eyes.length; i++) {
      var eye = eyes[i] || {};
      if (eye.sph !== null && (eye.sph < L.sphMin || eye.sph > L.sphMax)) return true;
      if (eye.cyl !== null && Math.abs(eye.cyl) > L.cylMax) return true;
    }

    return false;
  }

  /* -----------------------------------------------------------------------
     Render
     ----------------------------------------------------------------------- */
  function render(container) {
    var frameType = store.get('frameType') || 'clear';
    var rxType = store.get('prescriptionType') || 'single-vision';
    var lensPackage = store.get('lensPackage') || 'clear';
    var currentLensType = store.get('lensType');
    var rxValues = store.get('rxValues');

    var root = document.getElementById('wmp-prescription-flow');
    var questionIconUrl = root ? root.getAttribute('data-question-icon') : '';
    var infoIconHtml = questionIconUrl
      ? '<img src="' + questionIconUrl + '" alt="" aria-hidden="true" width="16" height="16" loading="eager">'
      : '?';

    var config = window.WmpProductsConfig;
    var lensTypes = config
      ? config.getLensTypes({ frameType: frameType, prescriptionType: rxType, lensPackageKey: lensPackage })
      : [];

    // Reading on clear frames does not support Premium AR in Step 4.
    // Sunglasses reading keeps Premium AR when configured.
    if (rxType === 'reading' && frameType === 'clear') {
      lensTypes = lensTypes.filter(function (t) { return t.lensTypeKey !== 'premium-ar'; });
    }

    lensTypes.sort(function (a, b) {
      var ao = LENS_TYPE_ORDER[a.lensTypeKey] || 999;
      var bo = LENS_TYPE_ORDER[b.lensTypeKey] || 999;
      if (ao !== bo) return ao - bo;
      return (a.title || a.lensTypeKey || '').localeCompare(b.title || b.lensTypeKey || '');
    });
    var ultraThinOnly = restrictToUltraThin(rxType, rxValues);
    var recommended = resolveRecommendedLensType(getRecommended(rxValues), lensTypes);

    // If prescriptionType is non-prescription, no recommended badge
    var showRecommended = rxType !== 'non-prescription';

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = 'CHOOSE LENS TYPE';
    container.appendChild(heading);

    if (!lensTypes.length) {
      var empty = document.createElement('p');
      empty.className = 'wmp-b1';
      empty.style.cssText = 'text-align:center;color:#999;padding:40px 20px;';
      empty.textContent = 'No lens types available for this selection.';
      container.appendChild(empty);
      return;
    }

    // Card list
    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    for (var i = 0; i < lensTypes.length; i++) {
      var lt = lensTypes[i];

      // All prescription types use Ultra-Thin exclusively when the entered Rx
      // falls outside the Standard/Premium cutting limits.
      if (ultraThinOnly && lt.lensTypeKey !== 'ultra-thin') continue;

      var displayName = lt.title
        ? lt.title.toString().toUpperCase()
        : (DISPLAY_NAMES[lt.lensTypeKey] || lt.lensTypeKey.toUpperCase());
      var description = lt.subtitle || DESCRIPTIONS[lt.lensTypeKey] || '';
      var isRecommended = showRecommended && lt.lensTypeKey === recommended;

      var card = document.createElement('div');
      card.className = 'wmp-card wmp-card--separate-controls';
      card.setAttribute('data-value', lt.lensTypeKey);
      card.setAttribute('data-price', String(lt.priceCents));
      card.setAttribute('data-variant-id', String(lt.variantId || ''));

      var selectControl = document.createElement('button');
      selectControl.className = 'wmp-card__select-control';
      selectControl.type = 'button';
      selectControl.setAttribute('aria-label', buildLensTypeCardLabel(lt, displayName, description, isRecommended));
      selectControl.setAttribute('aria-pressed', currentLensType === lt.lensTypeKey ? 'true' : 'false');
      selectControl.addEventListener('click', onCardClick);
      card.appendChild(selectControl);

      if (currentLensType === lt.lensTypeKey) card.classList.add('wmp-card--selected');

      // Icon (per-type)
      var iconEl = document.createElement('span');
      iconEl.className = 'wmp-card__icon';
      iconEl.setAttribute('aria-hidden', 'true');
      iconEl.innerHTML = TYPE_ICONS[lt.lensTypeKey] || TYPE_ICONS['standard'];
      card.appendChild(iconEl);

      // Content
      var content = document.createElement('div');
      content.className = 'wmp-card__content';

      var titleRow = document.createElement('div');
      titleRow.style.cssText = 'display:flex;align-items:center;gap:6px;flex-wrap:wrap;';

      var title = document.createElement('span');
      title.className = 'wmp-card__title';
      title.style.marginBottom = '0';
      title.textContent = displayName;
      titleRow.appendChild(title);

      // Info icon next to title
      if (lt.hasInfo) {
        var infoBtn = document.createElement('button');
        infoBtn.className = 'wmp-card__info';
        infoBtn.type = 'button';
        infoBtn.innerHTML = infoIconHtml;
        infoBtn.setAttribute('aria-label', 'More info about ' + displayName);
        infoBtn.setAttribute('aria-expanded', 'false');
        infoBtn.setAttribute('data-info-key', lt.lensTypeKey);
        infoBtn.setAttribute('data-info-content', lt.infoContent || '');
        infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          showLensTypeInfo(e.currentTarget);
        });
        infoBtn.addEventListener('mouseenter', function (e) {
          showLensTypeInfo(e.currentTarget);
        });
        infoBtn.addEventListener('focus', function (e) {
          showLensTypeInfo(e.currentTarget);
        });
        infoBtn.addEventListener('mouseleave', function (e) {
          if (document.activeElement !== e.currentTarget) WmpInfoBubble.hide();
        });
        infoBtn.addEventListener('blur', function () {
          WmpInfoBubble.hide();
        });
        titleRow.appendChild(infoBtn);
      }

      // Recommended badge — only exact key match (premium-ar never gets the badge)
      if (isRecommended) {
        var badge = document.createElement('span');
        badge.className = 'wmp-card__badge wmp-card__badge--recommended';
        badge.textContent = 'RECOMMENDED';
        titleRow.appendChild(badge);
      }

      content.appendChild(titleRow);

      var desc = document.createElement('span');
      desc.className = 'wmp-card__description';
      desc.style.cssText = 'display:block;margin-top:10px;';
      desc.textContent = description;
      content.appendChild(desc);

      card.appendChild(content);

      // Price — sale-aware (red sale + struck-through compare-at)
      var priceEl = document.createElement('span');
      priceEl.className = 'wmp-card__price';
      renderLensTypePrice(priceEl, lt.priceCents, lt.comparePriceCents);
      card.appendChild(priceEl);

      list.appendChild(card);
    }

    container.appendChild(list);
  }

  function onCardClick(e) {
    var card = e.currentTarget.closest ? e.currentTarget.closest('.wmp-card') : e.currentTarget.parentNode;
    if (!card) return;
    var value = card.getAttribute('data-value');
    var lensTypePrice = parseInt(card.getAttribute('data-price'), 10);
    var variantId = card.getAttribute('data-variant-id') || '';

    // Update visual selection
    var cards = card.parentNode.querySelectorAll('.wmp-card');
    for (var i = 0; i < cards.length; i++) {
      setCardSelected(cards[i], false);
    }
    setCardSelected(card, true);

    // Update store. Persist the resolved variant ID so Review adds the exact
    // variant the user picked (see lens-package step for rationale).
    store.set('lensType', value);
    store.set('lensTypeVariantId', variantId);

    // Update pricing — store lens type price separately; recalcLenses folds in
    // the package and any prism surcharge from Step 2.
    var pricing = store.get('pricing');
    pricing.lensType = lensTypePrice;
    store.set('pricing', pricing);
    store.recalcLenses();

    // Auto-advance
    if (advanceTimer) clearTimeout(advanceTimer);
    advanceTimer = setTimeout(function () {
      router.advance();
    }, 200);
  }

  function destroy() {
    if (advanceTimer) {
      clearTimeout(advanceTimer);
      advanceTimer = null;
    }
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['lens-type'] = {
    render: render,
    destroy: destroy
  };
})();
